import { changeUserPhoneApi } from '@eastcoal/api/auth/user/changeUserPhone'
import { sendSmsCodeToCurrentUserApi } from '@eastcoal/api/nexus/sms/sendSmsCodeToCurrentUser'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudModalForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { SmsInput } from '@eastcoal/formily/components/SmsInput'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { SmsTemplateCode } from '@eastcoal/shared/enums/SmsTemplateCode'

import { useAuthStore } from '../../hooks/useStore'

import { BindPhoneFormData, BindPhoneProps } from './interface'

const schema: SchemaItem[] = [
  {
    name: 'oldPhone',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: '{code: oldCode, ticketId: oldTicketId}',
    type: 'string',
    'x-component': SmsInput,
    'x-component-props': {
      api: sendSmsCodeToCurrentUserApi,
      requirePhone: false,
      templateCode: SmsTemplateCode.BIND_PHONE,
      comment: '手机号换绑',
      placeholder: '请填写当前手机的验证码'
    },
    'x-decorator': FormItem
  },
  {
    name: 'phone',
    type: 'string',
    'x-component': Input,
    'x-component-props': {
      placeholder: '请填写新手机号'
    },
    'x-decorator': FormItem,
    'x-validator': [
      {
        required: true,
        message: '请填写新手机号码'
      },
      {
        format: 'phone',
        message: '请填写有效的国内手机号码'
      },
      {
        validator(value, _, ctx) {
          const oldPhone = ctx.form.values.oldPhone
          if (oldPhone === value) {
            return '不能与旧手机号码相同'
          }
          return null
        }
      }
    ]
  },
  {
    name: '{code, ticketId}',
    type: 'string',
    'x-component': SmsInput,
    'x-component-props': {
      templateCode: SmsTemplateCode.BIND_PHONE,
      phone: '{{ $values.phone }}',
      comment: '绑定手机号',
      placeholder: '请填写新手机的验证码'
    },
    'x-decorator': FormItem
  }
]

export const BindPhone = ({
  onSuccess,
  /* -------------------------------------------------------------------------- */
  /*                            CrudModalForm Props                             */
  /* -------------------------------------------------------------------------- */
  open,
  onOpenChange
}: BindPhoneProps) => {
  const { phone } = useAuthStore(state => state.user)
  const form = useCreationForm()
  const api = async (values: BindPhoneFormData) => {
    const res = await changeUserPhoneApi(values, { silence: true })
    onSuccess?.(res)
  }

  return (
    <CrudModalForm
      form={form}
      mode={FormMode.UPDATE}
      name='bindPhone'
      open={open}
      schema={schema}
      size={400}
      title='手机换绑'
      updateApi={api}
      actions={[
        <CancelButton key='cancelButton' />,
        <SubmitButton key='submitButton' />
      ]}
      values={{
        oldPhone: phone
      }}
      onOpenChange={onOpenChange}
    />
  )
}
